import React from 'react';
import Select from '../../Form/Select';
import Input from '../../Form/Input';

interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
  setData: Function,
}

export default function RegistroImovel({ data, handleSelectChange, handleInputChange, setData }: TypeProps) {
  return (
    <form>
      <Input
        name="corretora"
        label="Corretora"
        type="text"
        placeholder={'Corretora'}
        data={data?.corretora || ''}
        setData={handleInputChange}
      />
      <Input
        name="locador"
        label="Locador (a)"
        type="text"
        placeholder={'Locador (a)'}
        data={data?.locador || ''}
        setData={handleInputChange}
      />
      <Input
        name="locatario"
        label="Locatário (a)"
        type="text"
        placeholder={'Locatário (a)'}
        data={data?.locatario || ''}
        setData={handleInputChange}
      />
      <Input
        name="vistoria"
        label="Vistoria"
        type="text"
        placeholder={'Vistoria'}
        data={data?.vistoria || ''}
        setData={handleInputChange}
      />

      <Select
        title="Imóvel"
        data={[
          { _id: 'apartamento padrao', name: 'Apartamento padrão' },
          { _id: 'apartamento cobertura', name: 'Apartamento de cobertura' },
          { _id: 'apartamento duplex', name: 'Apartamento duplex' },
          { _id: 'apartamento garden', name: 'Apartamento garden' },
          { _id: 'casa germinada', name: 'Casa Geminada' },
          { _id: 'sobrado', name: 'Sobrado' },
          { _id: 'bangalo', name: 'Bangalô' },
          { _id: 'edicula', name: 'Edícula' },
          { _id: 'kitnet', name: 'Kitnet' },
          { _id: 'loft', name: 'Loft' },
          { _id: 'mansao', name: 'Mansão' },
          { _id: 'flat', name: 'Flat' },
          { _id: 'studio', name: 'Studio' },
          { _id: 'loja', name: 'Loja' },
          { _id: 'deposito', name: 'Depósito' },
        ]}
        value={data?.imovel || ''}
        setSelected={(value: string) => { handleSelectChange('imovel', value) }}
      />

      <Input
        name="aluguel"
        label="Aluguel"
        type="text"
        placeholder={'Valor do aluguel'}
        data={data?.aluguel || ''}
        setData={handleInputChange}
      />
      <Input
        name="condominio"
        label="Condomínio"
        type="text"
        placeholder={'Valor do condomínio'}
        data={data?.condominio || ''}
        setData={handleInputChange}
      />


      <Select
        title="Prioridade"
        data={[
          { _id: 'Regular', name: 'Regular' },
          { _id: 'Alta', name: 'Alta' },
        ]}
        value={data?.prioridade || ''}
        setSelected={(value: string) => { handleSelectChange('prioridade', value) }}
      />

      <Input
        name="causa"
        label="Causa"
        type="text"
        placeholder={'Causa'}
        data={data?.causa || ''}
        setData={handleInputChange}
      />

      <Input
        name="resultado"
        label="Resultado"
        type="text"
        placeholder={'Resultado'}
        data={data?.resultado || ''}
        setData={handleInputChange}
      />
    </form>
  )
}